import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
	isPlatformBrowser
} from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { ENVIRONMENT } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SeoService {
	constructor(
		private _meta: Meta,
		private _title: Title,
		@Inject(DOCUMENT) private doc: Document,
		@Inject(PLATFORM_ID) private _platformID: Object,
	) {}

	setTitle( title: string ) {
		this._title.setTitle(title);
	}

	updateTags( tags: Array<{ name?: string, property?: string, content: string }> ) {
		tags.forEach(tag => this._meta.updateTag(tag));
	}

	setLink() {
		if ( isPlatformBrowser( this._platformID ) ) return;

		const requestPath = new URL( this.doc.URL || '/', ENVIRONMENT.APP_URL ).pathname;
		const canonicalUrl = new URL( requestPath, ENVIRONMENT.APP_URL ).toString();

		this.doc.querySelector( "link[rel='canonical']" )
		?.setAttribute( 'href', canonicalUrl );
	}
}
